import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { SchoolProfileSectionItem } from '@modules/types/graphql';

export type Entity = Partial<SchoolProfileSectionItem> | null;

@DecribeEntity('SchoolProfileItemEntity')
class SchoolProfileItemEntity extends BaseEntity {
    label: string;
    value: string;

    constructor(profileItem: Entity) {
        super(profileItem);

        this.label = profileItem?.label ?? '';
        this.value = profileItem?.value ?? '';
    }
}

export { SchoolProfileItemEntity };
